import type { ReactNode } from 'react';

export const symbol_ink_eraser_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M792-83 605-269l-85 90q-8.3 8.71-19.24 13.85Q489.82-160 477-160H204q-12.44 0-23.72-4.5T161-178l-63-66q-18-17-17.5-41.5T97-327l216-234L82-792q-9-9.07-9-21.53Q73-826 82.05-835q9.06-9 21.5-9 12.45 0 21.45 9l710 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83ZM206-220h274l83-91-209-209-212 234 64 66Zm654-348q1 11-3.07 21.96Q852.87-535.07 844-526L709-380q-8 9-20.83 9-12.84 0-22.17-9-8-8-8.5-20t7.5-21l139-151-207-217-141 157q-8 9-20 9.5t-20.87-8.37Q407-639 406.5-651q-.5-12 7.5-20l141-154q8-9 18.57-13 10.58-4 21.15-4 11.28 0 22.78 4 11.5 4 19.5 13l205 215q9 8 13.5 19.5T860-568Zm-319 63Zm-82 89Z"
		/>
	</svg>
);
